import React from "react";
import { Switch, Route } from "react-router-dom";
import StaffList from "./StaffList";
import NewStaff from "./NewStaff";
import EditStaff from "./EditStaff";
import AssignPatient from "./AssignPatient";
import Footer from "../../partials/footer";
import Navigation from "../../partials/navigation";
import Sidebar from "./partials/Sidebar";
import SearchStaff from "./Search";
import Profile from "./Profile";
import Dashboard from "./Dashboard";
import StaffSetting from "./Setting";
import auth from "../../providers/Auth.Provider";
import StaffLeaveList from "./Leave/StaffLeaveList";

const Staff = ({ history }) => {
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;

    const { id, admin } = GetToken() && GetAuthenticatedStaff();
    return (
        <>
            <div className="page-wrapper">
                <Navigation history={history} />
                <div className="page-container">
                    <Sidebar isAdmin={admin} id={id} />
                    <div className="page-content-wrapper page-content-wrapper-home">
                        <div className="page-content page-content-home">
                            <Switch>
                                <Route exact path="/home/staffing" component={Dashboard}></Route>
                                <Route path="/home/staffing/new" component={NewStaff}></Route>
                                <Route path="/home/staffing/list" component={StaffList}></Route>
                                <Route path="/home/staffing/edit" component={EditStaff}></Route>
                                <Route path="/home/staffing/search" component={SearchStaff}></Route>
                                <Route path="/home/staffing/assign-patient" component={AssignPatient}></Route>
                                <Route exact={true} path="/home/staffing/profile" component={Profile} />
                                <Route path="/home/staffing/profile/setting" component={StaffSetting} />
                                <Route path="/home/staffing/annual-leave" component={StaffLeaveList} />
                                <Route path="/home/staffing/dashboard" component={Dashboard} />
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};
export default Staff;
